export const selectTransaction = (state) =>
  state.get('transactionDetailContainer').get('transaction').toJS();
export const selectTransactionIsLoading = (state) =>
  state.get('transactionDetailContainer').get('transactionIsLoading');
export const selectTransactionErrorMessage = (state) =>
  state.get('transactionDetailContainer').get('transactionErrorMessage');
